








































































import { Vue, Component } from 'vue-property-decorator'
import { State } from 'vuex-class'
import ShareAPI from '@/util/api/ShareAPI'
import { RootState } from '@/store/types'
import { EditorEntry } from '@/store/editor/types'
import PCrypto from '@/util/crypto/PCrypto'
import { ShareLink } from '@/types/api/share'
import PStorage, { PRIVATE_KEY } from '@/util/PStorage'
import API from '@/util/api/API'

import ShareLinkModal from './ShareLinkModal.vue'
import ShareLinkItem from './ShareLinkItem.vue'

@Component({ name: 'share-links', components: { ShareLinkModal, ShareLinkItem } })
export default class ShareLinks extends Vue {
    // new link
    maxViews: number = 1
    recentLinkId: string = ''
    recentLinkKey: string = ''
    generatingLink: boolean = false

    // existing links
    links: ShareLink[] = []
    loadingLinks: boolean = false

    @State((state: RootState) => state.editor.entry)
    entry!: EditorEntry

    get activeLinks(): ShareLink[] {
        return this.links.filter(link => link.active && link.viewCount !== link.maxViews)
    }

    get inactiveLinks(): ShareLink[] {
        return this.links.filter(link => link.viewCount === link.maxViews)
    }

    mounted(): void {
        API.whenConnected(() => {
            this.getLinks()
        })
    }

    async getLinks(): Promise<void> {
        if (!this.loadingLinks) {
            this.loadingLinks = true
            this.links = await ShareAPI.getShareLinks(this.entry.id!)
            this.loadingLinks = false
        }
    }

    updateMaxViews(value: number): void {
        this.maxViews = value
    }

    async createLink(): Promise<void> {
        if (this.generatingLink) {
            this.$error({ text: 'A link is already being generated' })
            return
        }

        this.generatingLink = true
        const loading = this.$notice({ text: 'Generating link...', timeout: false })
        // get link id
        const { linkId } = await ShareAPI.shareLink(this.entry.id!, this.maxViews)

        // get decrypted document key
        const documentKey = PCrypto.RSA.decrypt(this.entry.documentKey!, PStorage.get(PRIVATE_KEY))

        // generate key
        const unlockKey = PCrypto.PBK(linkId, documentKey)
        const encDocumentKey = PCrypto.AES.encrypt(documentKey, unlockKey)

        const response = await ShareAPI.finalizeShareLink(linkId, encDocumentKey)

        loading.close()

        // set values for modal to show
        this.recentLinkId = linkId
        this.recentLinkKey = unlockKey

        await this.getLinks()
        this.generatingLink = false
    }

    async disableLink(linkId: string): Promise<void> {
        this.links = this.links.filter(link => link.linkId !== linkId)
        const response = await ShareAPI.disableLink(linkId)
        await this.getLinks()

        this.$notice({ text: 'Link disabled' })
    }

    closeModal(): void {
        this.recentLinkId = ''
        this.recentLinkKey = ''
    }
}
